import { render, staticRenderFns } from "./GrantAccessModal.vue?vue&type=template&id=1c5470a6&scoped=true"
import script from "./GrantAccessModal.vue?vue&type=script&lang=js"
export * from "./GrantAccessModal.vue?vue&type=script&lang=js"
import style0 from "./GrantAccessModal.vue?vue&type=style&index=0&id=1c5470a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5470a6",
  null
  
)

export default component.exports